var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('manage', 'gateway') && _vm.corporate_details)?_c('main-content',{attrs:{"with_go_back_bar":""}},[(_vm.corporate_details)?_c('div',[_c('corporate-form',{attrs:{"form_data":_vm.corporate_details,"submit":_vm.editCorporate}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }